
import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { getApiOrganizationSearch } from "../../../services/User/organizations";
import { apiRefreshToken } from "../../../services/Auth/login";
import useAuth from "../../../hooks/useAuth";

import { FaUser } from "react-icons/fa";

export default function Organization() {
    const { auth, login } = useAuth()
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(true);

    // Auth
    const organizationId = auth ? auth?.primaryUser?.organizationId : null

    const getOrganization = () => {
        setLoading(true);
        getApiOrganizationSearch()
            .then(res => {
                setOrganizations(res.data || []);
            })
            .catch(error => {
                setOrganizations([]);
                console.error(error)
            })
            .finally(() => setLoading(false));
    };

    const refreshToken = (id) => {
        apiRefreshToken({ organizationId: id })
            .then(res => {
                changeToken(res.data?.token)
            })
            .catch(error => {
                console.error("Error refreshing token:", error);
            });
    }


    const changeToken = async (token) => {
        await login({
            primaryUser: token,
            secondaryUser: auth?.secondaryUser,
        })
    }

    useEffect(() => {
        getOrganization();
    }, []);

    return (
        <div className="col-lg-9">
            <div className="card mb-3 mb-lg-5">
                <div className="card-header">
                    <h5 className="card-header-title">
                        Organizaciónes
                    </h5>
                </div>

                <div className="card-body">
                    <Grid container spacing={3}>
                        <Grid item md={12}>
                            <Grid container spacing={3}>
                                {loading ? (
                                    <Grid item xs={12}><Typography>Cargando...</Typography></Grid>
                                ) : organizations.length === 0 ? (
                                    <Grid item xs={12}><Typography>No hay organizaciones.</Typography></Grid>
                                ) : (
                                    organizations.map(org => (
                                        <Grid item xs={12} md={6} key={org.id}>
                                            <Card sx={{ display: 'flex', alignItems: 'center', minHeight: 120, borderRadius: '24px', boxShadow: 'none', border: '1.5px solid #e3e6ee', background: '#f6f6f6', paddingLeft: 2 }}>
                                                <Box
                                                    sx={{
                                                        height: 96,
                                                        width: 96,
                                                        minHeight: 64,
                                                        minWidth: 64,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderRadius: '16px',
                                                        background: '#fff',
                                                        border: '1.5px solid #e3e6ee',
                                                        mr: 3,
                                                        p: 1.5,
                                                    }}
                                                >
                                                    <Box
                                                        component="img"
                                                        src={org.logo || '/no-image-available.jpg'}
                                                        alt={org.name}
                                                        sx={{
                                                            maxHeight: '100%',
                                                            maxWidth: '100%',
                                                            objectFit: 'contain',
                                                            borderRadius: '10px',
                                                            background: '#fff',
                                                            boxShadow: '0 1px 4px 0 rgba(0,0,0,0.03)'
                                                        }}
                                                    />
                                                </Box>
                                                <CardContent sx={{ flex: 1 }}>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 1 }}>
                                                        <Typography variant="h6" component="div" sx={{ flex: 1, fontWeight: 700, fontSize: 20, color: '#223', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
                                                            {org.name}
                                                        </Typography>
                                                    </Box>
                                                    <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
                                                        <Button
                                                            variant="outlined"
                                                            color="primary"
                                                            size="small"
                                                            onClick={() => refreshToken(org.id)}
                                                            disabled={organizationId === org.id}
                                                            sx={{
                                                                flex: 1,
                                                                minWidth: 0,
                                                                fontSize: 13,
                                                                padding: '6px 0',
                                                                borderRadius: '16px',
                                                                background: '#f7fafd',
                                                                color: '#1976d2',
                                                                borderColor: '#bbdefb',
                                                                boxShadow: 'none',
                                                                transition: 'background 0.2s, border 0.2s',
                                                                '&:hover': {
                                                                    background: '#e3f2fd',
                                                                    borderColor: '#90caf9',
                                                                },
                                                            }}
                                                        >
                                                            Seleccionar
                                                        </Button>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    ))
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                </div>
            </div>
        </div>
    );
}
